module.exports = __webpack_public_path__ + "static/media/XML.d3a3f6f3.svg";